<button
  ngpButton
  [type]="type"
  [disabled]="disabled"
  [class]="buttonClasses"
  [attr.aria-label]="ariaLabel || (iconOnly ? label : null) || null"
  [attr.aria-busy]="loading || null"
  [attr.aria-pressed]="pressed === undefined ? null : pressed"
  [attr.aria-expanded]="expanded === undefined ? null : expanded"
  (click)="onClick($event)"
>
  @if (loading) {
    <span class="sui-button__spinner" aria-hidden="true"></span>
  } @else if (leadingIcon) {
    <span class="sui-button__icon" aria-hidden="true">
      <fa-icon
        [icon]="leadingIcon"
        [fixedWidth]="iconFixedWidth"
        [transform]="iconTransform"
      ></fa-icon>
    </span>
  }

  @if (label && !iconOnly) {
    <span class="sui-button__label">{{ label }}</span>
  }
  <ng-content></ng-content>

  @if (trailingIcon && !loading) {
    <span class="sui-button__icon sui-button__trailing" aria-hidden="true">
      <fa-icon
        [icon]="trailingIcon"
        [fixedWidth]="iconFixedWidth"
        [transform]="iconTransform"
      ></fa-icon>
    </span>
  }
</button>
